import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pn_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Do NOT auto-logout on 401 for public reads; only clear when explicitly unauthorized during token use
      const url = err?.config?.url || '';
      if (url.includes('/auth/me')) {
        localStorage.removeItem('pn_token');
      }
    }
    return Promise.reject(err);
  }
);

export const productImageUrl = (id) => `${API_BASE}/products/${id}/image`;
export const productDocumentUrl = (productId, attachmentId) => `${API_BASE}/products/${productId}/documents/${attachmentId}`;
